var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInkPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_11541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.825L10.175 8.75L15.6 3.325L14.675 2.4L9.25 7.825ZM2 16H2.925L8.75 10.175L7.825 9.25L2 15.075V16ZM10.875 10.875L7.125 7.125L11.3 2.95L10.575 2.225L5.1 7.7L3.7 6.3L9.15 0.825C9.55 0.425 10.0208 0.225 10.5625 0.225C11.1042 0.225 11.575 0.425 11.975 0.825L12.7 1.55L13.95 0.3C14.15 0.1 14.3875 0 14.6625 0C14.9375 0 15.175 0.1 15.375 0.3L17.7 2.625C17.9 2.825 18 3.0625 18 3.3375C18 3.6125 17.9 3.85 17.7 4.05L10.875 10.875ZM3.75 18H0V14.25L7.125 7.125L10.875 10.875L3.75 18Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_11541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkPen);
export default __webpack_public_path__ + "static/media/ink_pen.1ef4dee406e24c5ab0f10319b6b5bdfc.svg";
export { ForwardRef as ReactComponent };